import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router';
import SettingsAccountPage from './SettingsAccountPage';
import SettingAWSPage from './SettingsAWSPage';
import SettingsDomainPage from './SettingsDomainPage';
import SettingGooglePage from './SettingsGooglePage';
import SettingTikTokPage from './SettingsTikTokPage';
import SettingsUserPage from './SettingsUserPage';

const SettingsPage = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (location.pathname.endsWith('/settings')) {
      navigate(location.pathname + '/domain', { replace: true });
    }
  }, [location, navigate]);

  if (location.pathname.endsWith('/settings')) {
    return '';
  }

  let subpage = '';
  if (location.pathname.endsWith('/domain')) {
    subpage = <SettingsDomainPage />;
  } else if (location.pathname.endsWith('/account')) {
    subpage = <SettingsAccountPage />;
  } else if (location.pathname.endsWith('/user')) {
    subpage = <SettingsUserPage />;
  } else if (location.pathname.endsWith('/google')) {
    subpage = <SettingGooglePage />;
  } else if (location.pathname.endsWith('/aws')) {
    subpage = <SettingAWSPage />;
  } else if (location.pathname.endsWith('/tiktok')) {
    subpage = <SettingTikTokPage />;
  }

  return subpage;
};

export default SettingsPage;
